export const defaults = {
    gridProps: {
        postsRelated: [],
        title: 'Related Articles',
        label: 'See More'
    },
}
